import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DynamicTableColumnModel } from '../../../models/dto/core/dynamicTableColumn.model';
import { UserSessionStorageMergeRequest } from '../../../models/rest/user/user-session-storage-merge-request';
import { AlertifyService } from '../../../services/core/alertify.service';
import { ColumnVisibleService } from '../../../services/core/column-visible.service';
import { UserSessionStorageService } from '../../../services/user/user-session-storage.service';



@Component({
  selector: 'app-modify-columns-modal',
  templateUrl: './modify-columns-modal.component.html',
  styleUrls: ['./modify-columns-modal.component.css']
})
export class ModifyColumnsModalComponent implements OnInit {
  @Input() screenCode: string;
  @Input() reportType: string;
  @Input() availableColumns: DynamicTableColumnModel[];

  selectedColumns: DynamicTableColumnModel[] = [];
  unselectedColumns: DynamicTableColumnModel[] = [];

  @Output() valueChange: EventEmitter<DynamicTableColumnModel[]> = new EventEmitter();

  constructor(private columnVisibleService: ColumnVisibleService,
    private userSessionStorageService: UserSessionStorageService,
    private alertifyService: AlertifyService
  ) {

  }
  ngOnInit() {
    this.availableColumns = this.availableColumns.filter(x => !x.isHidden);
    // Local storage'dan daha önce seçilen alanları al
    let storedFields: string[] = this.columnVisibleService.getVisibleColumns(this.screenCode, this.reportType);

    if (storedFields.length == 0) {
      storedFields = this.columnVisibleService.getInitialVisibleColumn(this.reportType, this.availableColumns)
    }


    if (storedFields.length > 0) {
      this.selectedColumns = this.availableColumns.filter(column => storedFields.includes(column.field));

      // fields dizisindeki sıraya göre selectedColumns dizisini sırala
      this.selectedColumns.sort((a, b) => storedFields.indexOf(a.field) - storedFields.indexOf(b.field));
    }

    this.unselectedColumns = this.availableColumns.filter(column => !this.isSelected(column));
  }

  isSelected(column: DynamicTableColumnModel): boolean {
    return this.selectedColumns.some(selectedColumn => selectedColumn.field === column.field);
  }

  async save() {
    const selectedFields: string[] = this.selectedColumns.map(column => column.field);

    // Seçilen sütun alanlarını local storage'a kaydet
    this.columnVisibleService.setVisibleColumns(this.screenCode, this.reportType, selectedFields);

    await this.saveToDatabase(selectedFields);

    // Parent component'e güncellenen sütun alanlarını bildir
    this.valueChange.emit(this.selectedColumns);
  };

  async saveToDatabase(value: string[]) {

    try {
      let request = new UserSessionStorageMergeRequest();

      request.key = this.columnVisibleService.getKey(this.screenCode, this.reportType);
      request.value = JSON.stringify(value);

      await this.userSessionStorageService.mergeUserSessionStorage(request).toPromise();

    }
    catch (err) {
      this.alertifyService.error(err);
    }
  }

  reset(
  ) {
    this.selectedColumns = [];
    this.save();
  }

  close() {
    this.valueChange.emit();
  };
}
